// extracted by mini-css-extract-plugin
export default {"header_links":"Checkin_header_links__osV7W","header_links_box":"Checkin_header_links_box__fCKVO","header_link":"Checkin_header_link__H2AFY"};